import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

const initialTutoriaState: ILoanPurposeState = {
  data: {
    loanPurpose: [],
    meta: {},
  },
  deleteSuccess: false,
  loading: false,
  success: false,
}

export interface ILoanPurposeState {
  data?: {
    loanPurpose?: []
    meta?: {[key: string]: number}
  }
  activateSuccess?: boolean
  deactivateSuccess?: boolean
  singleActivateSuccess?: boolean
  singleDeactivateSuccess?: boolean
  deleteSuccess?: boolean
  loading?: boolean
  success?: boolean
}

export const reducer = (
  state: ILoanPurposeState = initialTutoriaState,
  action: ActionWithPayload<ILoanPurposeState>
) => {
  switch (action.type) {
    case actionTypes.GET_LOAN_PURPOSE_START: {
      return {...state, loading: true}
    }

    case actionTypes.GET_LOAN_PURPOSE_SUCCESS: {
      return {...state, data: action.payload, loading: false}
    }

    case actionTypes.GET_LOAN_PURPOSE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_LOAN_PURPOSE_START: {
      return {...state, loading: true}
    }

    case actionTypes.ADD_LOAN_PURPOSE_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.ADD_LOAN_PURPOSE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.ADD_LOAN_PURPOSE_RESET: {
      return {
        ...state,
        data: [],
        success: false,
      }
    }

    case actionTypes.UPDATE_LOAN_PURPOSE_START: {
      return {...state, loading: true}
    }

    case actionTypes.UPDATE_LOAN_PURPOSE_SUCCESS: {
      return {
        ...state,
        data: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.UPDATE_LOAN_PURPOSE_FINISH: {
      const error = action.payload
      return {...state, error, loading: false}
    }

    case actionTypes.DELETE_LOAN_PURPOSE_START: {
      return {...state, loading: true}
    }

    case actionTypes.DELETE_LOAN_PURPOSE_SUCCESS: {
      return {
        ...state,
        deleteSuccess: true,
        loading: false,
      }
    }

    case actionTypes.DELETE_LOAN_PURPOSE_FINISH: {
      return {
        ...state,
        loading: false,
        deleteSuccess: false,
      }
    }

    case actionTypes.SINGLE_ACTIVATE_LOAN_PURPOSE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_ACTIVATE_LOAN_PURPOSE_SUCCESS: {
      return {...state, activateSuccess: true, loading: false}
    }
    case actionTypes.SINGLE_ACTIVATE_LOAN_PURPOSE_FINISH: {
      return {...state, activateSuccess: false, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_LOAN_PURPOSE_REQUEST: {
      return {...state, loading: true}
    }

    case actionTypes.SINGLE_DEACTIVATE_LOAN_PURPOSE_SUCCESS: {
      return {...state, deactivateSuccess: true, loading: false}
    }

    case actionTypes.SINGLE_DEACTIVATE_LOAN_PURPOSE_FINISH: {
      return {...state, deactivateSuccess: false, loading: false}
    }

    case actionTypes.SORT_LOAN_PURPOSE_START: {
      return {...state, loading: true}
    }

    case actionTypes.SORT_LOAN_PURPOSE_SUCCESS: {
      return {
        ...state,
        sortLoanPurposeData: action?.payload,
        success: true,
        loading: false,
      }
    }

    case actionTypes.SORT_LOAN_PURPOSE_FINISH: {
      return {
        ...state,
        loading: false,
        success: false,
      }
    }

    case actionTypes.SORT_LOAN_PURPOSE_RESET: {
      return {
        ...state,
        loading: false,
        success: false,
        sortLoanPurposeData: [],
      }
    }

    default:
      return state
  }
}
